export enum DeepLinkPage {
  MFA = 'mfa',
}
